import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  HashRouter,
} from "react-router-dom";
import BoxPayLogin from "./components/pages/Login/BoxPayLogin";
import ProtectedRoute from "./components/pages/ProtectedRoute";
import PageNotFound from "./components/pages/PageNotFound";
import AddPaymentGateways from "./components/pages/Configurations/Payment Gateways/AddPaymentGateways";
import ViewPaymentGateways from "./components/pages/Configurations/Payment Gateways/ViewPaymentGateways";
import SuccessRate from "./components/pages/SuccessRate";
import TransactionStat from "./components/pages/TransactionStat";
import Gmv from "./components/pages/Gmv";
import Simulator from "./components/pages/Simulator";
import OrderDetails from "./components/pages/orderManagement/OrderDetails/OrderDetails";
import Transactions from "./components/pages/orderManagement/Transactions";
import ApiCreds from "./components/pages/Developers/API Credentials/ApiCreds";
import BatchRefund from "./components/pages/refund/batchRefund/batchRefund";
import BatchRefundDetails from "./components/pages/refund/batchRefund/batchRefundDetails";
import Home from "./components/pages/Home/home";
import Checkout from "./components/pages/checkout/checkout";
import Analytics from "./components/pages/analytics/analytics";
import PaymentLinks from "./components/pages/paymentLink/paymentLinks";
import CreatePaymentLinks from "./components/pages/paymentLink/createPaymentLinks";
import UserProfile from "./components/pages/userProfile/userProfile";
import AdminProfile from "./components/pages/adminProfile/adminProfile";
import Reports from "./components/pages/reports/reports";
import GenerateReports from "./components/pages/reports/generateReports";
import AccessDeniedPage from "./components/reusableComponents/accessDenied/accessDeniedPage";
import { useAuth } from "./components/context/API_Client";
import Routing from "./components/pages/routingRule";
import RoutingConfig from "./components/pages/Routing/RoutingConfig";
import BusinessUnit from "./components/pages/businessUnit/businessUnit";
import Webhook from "./components/pages/Developers/Notification Logs/webhook";
import LogsDetails from "./components/pages/Developers/Notification Logs/WebhookLogs/logsDetails";
import CreateWebhook from "./components/pages/Developers/Notification Logs/Webhook/createWebhook";
import Products from "./components/pages/products/products";
import WebhookDetails from "./components/pages/Developers/Notification Logs/Webhook/WebhookDetails";
import ManageUsers from "./components/pages/managerUsers/manageUsers";
import CreateRole from "./components/pages/managerUsers/roles/createRole";
import MenuBar from "./components/pages/MenuBar";
import Header from "./components/pages/Header";
import Footer from "./components/pages/Footer";
import { isMasqueradeUrl } from "./components/pages/utils/utils";
import MasqueradeLogin from "./components/pages/Login/MasqueradeLogin";
import SamlTokenHandler from "./components/pages/Login/SamlTokenHandler";
import Recon from "./components/pages/PaymentReconciliation/Recon";
import { mappingFunction } from "./LinkToFeatureMap";
import { OrderManagementProvider } from "./components/context/orderManagement.context";
import { OfferMangementProvider } from "./components/context/offerManagement.context";
import OfferManagement from "./components/pages/offerManagementT/OfferManagement";
import CreateNoOrLowCostEmi from "./components/pages/offerManagementT/noOrLowCostEmi/createNoOrLowCostEmi/createNoOrLowCostEmi";
import { colorBrandObject } from "./constants/brandings";
import AddRedirectInfo from "./components/pages/Redirects/AddRedirectInfo";
import EditNoOrLowCostEmi from "./components/pages/offerManagementT/noOrLowCostEmi/editNoOrLowCostEmi/editNoOrLowCostEmi";
import ApprovalRequest from "./components/pages/ApprovalRequest/ApprovalRequest";
import Reconciliation from "./components/pages/Reconciliation/Reconciliation";
import { GenericReconProvider } from "./components/context/genericRecon.context";

function RouteManager() {
  // navigateToAvailableRoute
  const { isLoggedIn, NavigateToAvailableRoute } = useAuth();
  let simulatorPage;
  const loginUser = localStorage?.getItem("userDetails");
  const userObject = JSON.parse(loginUser);
  const enableDemo = process.env.REACT_APP_ENABLE_DEMO === "true";

  useEffect(() => {
    const storedBrandColors = localStorage.getItem("brandColors");
    if (storedBrandColors) {
      const parsedData = JSON.parse(storedBrandColors);
      for (let key in parsedData) {
        if (colorBrandObject.hasOwnProperty(key) && parsedData[key]) {
          colorBrandObject[key] = parsedData[key];
        }
      }
    }
  }, []);

  if (enableDemo) {
    simulatorPage = (
      <Route
        exact
        path="/demo/simulator"
        element={<ProtectedRoute ProtRoute={Simulator} />}
      />
    );
  }
  const getRoute = (
    path,
    feature,
    permission,
    operationPermissions,
    route,
    provider,
    index
  ) => {
    return (
      <Route
        key={index}
        exact
        path={path}
        element={
          <ProtectedRoute
            ProtRoute={route}
            Feature={feature}
            Permission={permission}
            operationPermissions={operationPermissions}
            Provider={provider}
          />
        }
      />
    );
  };

  const featureMappingArray = [
    {
      path: "/home",
      feature: "ANALYTICS",
      component: Home,
    },
    {
      path: "/payment_gateway_configurations/add_payment_gateways",
      feature: "PAYMENT_GATEWAYS",
      permission: "ADD_PAYMENT_GATEWAY",
      operationPermissions: {
        updatePG: "UPDATE_PAYMENT_GATEWAY",
      },
      component: AddPaymentGateways,
    },
    {
      path: "/payment_gateway_configurations",
      feature: "PAYMENT_GATEWAYS",
      permission: "VIEW_GATEWAY_CONFIGURATIONS",
      operationPermissions: {
        createPG: "ADD_PAYMENT_GATEWAY",
        updatePG: "UPDATE_PAYMENT_GATEWAY"
      },
      component: ViewPaymentGateways,
    },
    {
      path: "/checkout",
      feature: "MERCHANT_SETTINGS",
      component: Checkout,
    },

    {
      path: "/transactions/batchRefund/batchRefundDeatils",
      feature: "ORDER_MANAGEMENT",
      permission: "VIEW_ORDER_DETAILS",
      component: BatchRefundDetails,
    },
    {
      path: "/transactions/batchRefund",
      feature: "ORDER_MANAGEMENT",
      permission: "VIEW_ORDERS",
      component: BatchRefund,
    },
    {
      path: "/transacs/payment_details/transaction_Details",
      feature: "ORDER_MANAGEMENT",
      // permission: "VIEW_ORDER_DETAILS",
      operationPermissions: {
        viewOrderDetails: "VIEW_ORDER_DETAILS",
        viewOwnOrderDetails: "VIEW_OWN_ORDER_DETAILS",
      },
      component: OrderDetails,
    },
    {
      path: "/approvals/detail",
      feature: "REFUND_REVIEW",
      operationPermissions: {
        viewOrderDetails: "VIEW_ORDER_DETAILS",
        viewOwnOrderDetails: "VIEW_OWN_ORDER_DETAILS",
      },
      component: OrderDetails,
    },
    {
      path: "/approvals",
      feature: "REFUND_REVIEW",
      permission: "REFUND_REVIEW_PAYMENT",
      operationPermissions: {
        // viewOrderDetails: "VIEW_ORDER_DETAILS",
        // viewOwnOrderDetails: "VIEW_OWN_ORDER_DETAILS",
      },
      component: ApprovalRequest,
    },
    {
      path: "/transactions",
      feature: "ORDER_MANAGEMENT",
      // permission: "VIEW_ORDERS",
      operationPermissions: {
        viewOrder: "VIEW_ORDERS",
        viewOwnOrder: "VIEW_OWN_ORDERS",
      },
      component: Transactions,
      provider: OrderManagementProvider,
    },
    {
      path: "/routing/updateRoutingRule",
      feature: "PAYMENT_ROUTING_RULES",
      permission: "UPDATE_ROUTING_RULES",
      component: RoutingConfig,
    },

    {
      path: "/routing/createRoutingRule",
      feature: "PAYMENT_ROUTING_RULES",
      permission: "ADD_ROUTING_RULE",
      component: RoutingConfig,
    },
    {
      path: "/routing",
      feature: "PAYMENT_ROUTING_RULES",
      permission: "VIEW_ROUTING_RULES",
      operationPermissions: {
        deleteRoutingRule: "DELETE_ROUTING_RULE",
        updateRoutingRule: "UPDATE_ROUTING_RULE",
        addRoutingRule: "ADD_ROUTING_RULE",
      },
      component: Routing,
    },

    {
      path: "/paymentLinks/createPaymentlink",
      feature: "PAYMENT_LINKS",
      permission: "CREATE_PAYMENT_LINK",
      component: CreatePaymentLinks,
    },
    {
      path: "/paymentLinks/editPaymentlink",
      feature: "PAYMENT_LINKS",
      permission: "CREATE_PAYMENT_LINK",
      component: CreatePaymentLinks,
    },

    {
      path: "/paymentLinks",
      feature: "PAYMENT_LINKS",
      operationPermissions: {
        viewAllLinks: "VIEW_ALL_PAYMENT_LINKS",
        viewOwnLinks: "VIEW_OWN_PAYMENT_LINKS",
        createPaymentLink: "CREATE_PAYMENT_LINK",
        updateMerchantSetting: "UPDATE_MERCHANT_SETTINGS",
      },
      component: PaymentLinks,
    },
    {
      path: "/paymentReconciliation",
      feature: "RECON",
      permission: "VIEW_RECON_REPORTS",
      operationPermissions: {
        viewReports: "VIEW_RECON_REPORTS",
        uploadSettlementFile: "CREATE_RECON_REPORT",
        downloadConflictFile: "DOWNLOAD_CONFLICT_FILE",
      },
      component: Recon,
    },
    {
      path: "/reconciliation/:reconId",
      feature: "RECON_RECORD_FILES",
      permission: "GET_GEN_RECON_RECORD_FILES",
      operationPermissions: {
        uploadRecord: "UPLOAD_GEN_RECON_RECORD_FILE",
        tablePermission: "GET_GEN_RECON_RECORD_FILES",
        rollbackPermission: "ROLLBACK_GEN_RECON_RECORD_FILE",
        downloadSkippedRecord: "DOWNLOAD_GEN_RECON_SKIPPED_RECORD_FILE",
        viewMerchantReportDashBoard: "VIEW_MERCHANT_GEN_RECON_DASHBOARD",
        viewReports: "VIEW_MERCHANT_GEN_RECON_REPORTS",
        createGenReconReport: "CREATE_MERCHANT_GEN_RECON_REPORT",
        downloadGenReconReport: "DOWNLOAD_MERCHANT_GEN_RECON_REPORT",
      },
      component: Reconciliation,
      provider: GenericReconProvider
      // component: ReconciliationFile,
    },
    // {
    //   path: "/reconciliation/generateReport/:reconId",
    //   feature: "RECON_REPORTS",
    //   permission: "VIEW_MERCHANT_GEN_RECON_REPORTS",
    //   operationPermissions: {
    //     viewReports: "VIEW_MERCHANT_GEN_RECON_REPORTS",
    //     createGenReconReport: "CREATE_MERCHANT_GEN_RECON_REPORT",
    //     downloadGenReconReport: "DOWNLOAD_MERCHANT_GEN_RECON_REPORT",
    //   },
    //   component: GenerateReconReport,
    // },
    {
      path: "/analytics",
      feature: "ANALYTICS",
      component: Analytics,
    },
    {
      path: "/developers/webhooks/webhookDetail",
      feature: "WEBHOOKS",
      component: WebhookDetails,
    },
    {
      path: "/developers/webhooks/editWebhook",
      feature: "WEBHOOKS",
      permission: "UPDATE_WEBHOOK",
      component: CreateWebhook,
    },
    {
      path: "/developers/webhooks/createWebhook",
      feature: "WEBHOOKS",
      permission: "ADD_WEBHOOK",
      component: CreateWebhook,
    },
    {
      path: "/developers/webhooks/notifications_Details",
      feature: "WEBHOOKS",
      component: LogsDetails,
    },

    {
      path: "/developers/webhooks",
      feature: "WEBHOOKS",
      permission: "VIEW_WEBHOOKS",
      operationPermissions: {
        createWebhook: "ADD_WEBHOOK",
        updateWebhook: "UPDATE_WEBHOOK",
        deleteWebhook: "dELETE_WEBHOOK",
      },
      component: Webhook,
    },

    {
      path: "/developers/api_credentials",
      feature: "API_KEYS",
      permission: "VIEW_API_KEYS",
      operationPermissions: {
        createAPIKey: "CREATE_API_KEYS",
      },
      component: ApiCreds,
    },
    {
      path: "/settings/business_unit",
      feature: "LEGAL_ENTITIES",
      permission: "VIEW_LEGAL_ENTITIES",
      operationPermissions: {
        createLegalEntity: "ADD_LEGAL_ENTITY",
        updateLegalEntity: "UPDATE_LEGAL_ENTITY",
        deleteLegalEntity: "DELETE_LEGAL_ENTITY",
        businessUnitsPresent: userObject?.businessUnits,
      },
      component: BusinessUnit,
    },

    {
      path: "/settings/product_catalogue",
      feature: "PRODUCTS",
      operationPermissions: {
        createProduct: "ADD_PRODUCT",
        updateProduct: "UPDATE_PRODUCT",
        deleteProduct: "DELETE_PRODUCT",
      },
      component: Products,
    },
    {
      path: "/settings/manageTeam/editRole",
      feature: "USER_ROLES_MANAGEMENT",
      permission: "EDIT_ROLE",
      component: CreateRole,
    },

    {
      path: "/settings/manageTeam/createRole",
      feature: "USER_ROLES_MANAGEMENT",
      permission: "ADD_ROLE",
      component: CreateRole,
    },

    {
      path: "/offerManagement",
      feature: "OFFERS",
      permission: "VIEW_OFFERS",
      operationPermissions: {
        addOffer: "ADD_OFFER",
      },
      component: OfferManagement,
      provider: OfferMangementProvider,
    },
    {
      path: "/offerManagement/createEmiOffer",
      permission: "ADD_OFFER",
      component: CreateNoOrLowCostEmi,
      provider: OfferMangementProvider,
    },
    {
      path: "/offerManagement/editEmiOffer",
      permission: "UPDATE_OFFER",
      component: EditNoOrLowCostEmi,
      provider: OfferMangementProvider,
    },

    {
      path: "/settings/manageTeam",
      feature: "USER_ROLES_MANAGEMENT",
      permission: "VIEW_USERS",
      operationPermissions: {
        createUser: "ADD_USER",
        updateUser: "EDIT_USER",
        deleteUser: "DELETE_USER",
        createRole: "ADD_ROLE",
        updateRole: "EDIT_ROLE",
        deleteRole: "DELETE_ROLE",
      },
      component: ManageUsers,
    },

    {
      path: "/reports/createReport",
      feature: "MERCHANT_REPORTS",
      permission: "CREATE_MERCHANT_REPORT",
      component: GenerateReports,
    },
    {
      path: "/reports",
      feature: "MERCHANT_REPORTS",
      permission: "VIEW_MERCHANT_REPORTS",
      operationPermissions: {
        createReport: "CREATE_MERCHANT_REPORT",
        downloadReport: "DOWNLOAD_MERCHANT_REPORT",
      },
      component: Reports,
    },
    {
      path: "/reports/success_rate",
      component: SuccessRate,
    },
    {
      path: "/reports/trans_stat",
      component: TransactionStat,
    },
    {
      path: "/reports/gmv",
      component: Gmv,
    },
    {
      path: "/demo/simulator",
      component: Simulator,
    },
    {
      path: "/userProfile",
      component: UserProfile,
    },
    {
      path: "/adminProfile",
      operationPermissions: {
        updateMerchantSetting: "UPDATE_MERCHANT_SETTINGS",
      },
      component: AdminProfile,
    },
  ];

  mappingFunction(featureMappingArray);


  return (
    <div className="wrapper">
      <Router history={HashRouter}>
        {isLoggedIn ? (
          <>
            <Header />
            <MenuBar />
            <Routes>
              <Route exact path="/" element={<NavigateToAvailableRoute />} />
              {featureMappingArray.map((object, index) => {
                return getRoute(
                  object?.path,
                  object?.feature,
                  object?.permission,
                  object?.operationPermissions,
                  object?.component,
                  object?.provider,
                  index
                );
              })}
              <Route
                exact
                path="/accessDenied"
                element={<AccessDeniedPage />}
              />
              <Route exact path="/token" element={<SamlTokenHandler />} />
              <Route exact path="*" element={<PageNotFound />} />
            </Routes>
            <Footer />
          </>
        ) : (
          <Routes>
            {isMasqueradeUrl() ? (
              <>
                <Route exact path="/token" element={<SamlTokenHandler />} />
                <Route exact path="/" element={<MasqueradeLogin />} />
              </>
            ) : (
              <Route exact path="/" element={<BoxPayLogin />} />
            )}
            <Route exact path="*" element={<AddRedirectInfo />} />
          </Routes>
        )}
      </Router>
    </div>
  );
}

export default RouteManager;
